import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import './styles.css';
import { connect } from '../../reducers/index';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import ImageHero from '../../components/ImageBanner';
import MHModal from '../../components/MentalModal';
import MonitorGraphic from './img/website-on-monitor@3x.png';

const MentalHealthPage = props => (
  <div className="mental-health-fwk">
    <Navigation role={props.role} />
    <ImageHero
      childTitle={'Mental Health Framework'}
      childContent={
        'The World Health Organization defines mental health as, "a state of well-being in which every individual realizes his or her own potential, can cope with the normal stresses of life, can work productively and fruitfully, and is able to make a contribution to her or his community".'
      }
    />
    <section>
      <div id="maincontent" className="container">
        <Row className="text-center">
          <Col xs={12} md={8} mdOffset={2}>
            <p className="quote">
              Mental health has also been described as being measured along a
              dual continuum, having many stages between flourishing and
              languishing.
            </p>
            <p>
              <small>Keyes, 2007</small>
            </p>
          </Col>
        </Row>
      </div>
    </section>
    <section>
      <div className="container">
        <Row className="text-center">
          <Col xs={12} md={8} mdOffset={2} className="relative">
            <MHModal />
          </Col>
        </Row>
      </div>
    </section>
    <section className="no-padd bg-mnblue row">
      <Col xs={12} sm={12} md={6} className="bg-ltblue">
        <div className="padd">
          <h2 className="no-bold txt-ltblue">Why is training so important?</h2>
          <p>
            The University&apos;s recent Mental Health Strategy recommends a
            broader systemic approach towards student mental health. This
            approach requires participation at individual, departmental and
            institutional levels, as well as the need to look beyond the
            University to health-care community partners to help provide
            students with appropriate mental health support.
          </p>
          <p>
            Several of these recommendations ask the community to provide a
            supportive role in helping to change the academic culture to one
            that recognizes help-seeking as a positive or strength, and in
            helping students navigate the support services and programs
            available to them.
          </p>
        </div>
      </Col>
      <Col xs={12} sm={12} md={6} className="txt-white nib">
        <div className="padd">
          <h2 className="no-bold">These recommendations include:</h2>
          <p>
            Create a ‘<strong>roadmap</strong>’ to facilitate student navigation
            of services and programs that begins with enhanced programming at
            orientation and continues throughout the academic year, delivering
            education and information to the University community.
          </p>
          <p>
            Develop programming and training that supports faculty members,
            graduate supervisors and teaching assistants to create learning
            environments that encourage students to seek help without fear of
            judgment or repercussions.
          </p>
        </div>
      </Col>
    </section>
    <section>
      <div className="container">
        <Row className="text-center">
          <Col xs={12} md={12}>
            <h2 className="no-bold txt-ltblue">
              Mental Health issues from the academic level
            </h2>
            <h3>
              Common challenges that have a significant impact on student&apos;s
              academics at the post-secondary level:
            </h3>
          </Col>
        </Row>
        <Row className="text-center">
          <table className="table-responsive">
            <tbody>
              <tr>
                <td>
                  <p>43%</p> stress
                </td>
                <td>
                  <p>33%</p> anxiety
                </td>
                <td>
                  <p>29%</p> sleep difficulties
                </td>
                <td>
                  <p>22%</p> depression
                </td>
                <td>
                  <p>20%</p> internet use / computer games
                </td>
                <td>
                  <p>17%</p> work
                </td>
                <td>
                  <p>16%</p> concern for friend / family
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <small>
              <strong>Reference:</strong> ACHA-NCHA. 2016. Ontario Reference
              Group
            </small>
          </p>
        </Row>
      </div>
    </section>
    <section className="bg-ltblue bg-report">
      <div className="container">
        <Row>
          <Col xs={12} md={6}>
            <img
              className="img-block img-responsive"
              src={MonitorGraphic}
              width="410"
              alt="Monitor with website on screen"
            />
          </Col>
          <Col xs={12} md={6}>
            <h2 className="no-bold txt-ltblue">
              Access Mental Health Framework Report
            </h2>
            <p>
              Introducing a perspective on student mental wellness that includes
              everyone.
            </p>
            <p>
              <Button
                className="btn-blue"
                target="_blank"
                rel="noopener noreferrer"
                href="http://mentalhealth.utoronto.ca/sites/default/files/Report%20on%20Student%20Mental%20Health%202014.pdf"
              >
                Download report
              </Button>
            </p>
            <p>
              <Button
                target="_blank"
                rel="noopener noreferrer"
                className="btn-blue"
                href="http://mentalhealth.utoronto.ca/"
              >
                Visit website
              </Button>
            </p>
          </Col>
        </Row>
      </div>
    </section>
    <Footer />
  </div>
);

MentalHealthPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const Mental = connect.role(MentalHealthPage);

export default Mental;



// WEBPACK FOOTER //
// ./src/containers/Mental/index.jsx